import { render, staticRenderFns } from "./BackBar.vue?vue&type=template&id=207125a5&scoped=true"
import script from "./BackBar.vue?vue&type=script&lang=js"
export * from "./BackBar.vue?vue&type=script&lang=js"
import style0 from "./BackBar.vue?vue&type=style&index=0&id=207125a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207125a5",
  null
  
)

export default component.exports